import type {
  ServiceResponseError,
  ServiceResponseSuccess,
} from '@/contexts/shared/service-response/ServiceResponse.interfaces'
import type { TranslatedFields } from '@/interfaces/Language.interfaces'

export const serviceSuccess = <T>(data: T): ServiceResponseSuccess<T> => {
  return {
    ok: true,
    data,
  }
}

export const serviceError = <T>(
  type: string | number,
  message: string | TranslatedFields = ''
): ServiceResponseError<T> => {
  return {
    ok: false,
    error: { type, message },
  }
}
